import { render, staticRenderFns } from "./lottery-analysis.vue?vue&type=template&id=3f634d16&scoped=true&"
import script from "./lottery-analysis.vue?vue&type=script&lang=ts&"
export * from "./lottery-analysis.vue?vue&type=script&lang=ts&"
import style0 from "./lottery-analysis.vue?vue&type=style&index=0&id=3f634d16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f634d16",
  null
  
)

export default component.exports